<template>
<div></div>
</template>
<script>
import { userDbindEmailOpenId } from '@/api/api.js'
export default {
  data() {
    return {

    }
  },
  mounted() {
    let params = {
      email: this.$route.query.email,
      code: this.$route.query.code
    }
    userDbindEmailOpenId(params).then(res => {
      console.log(res)
      if (res.code === 0) {
        // 清除所有缓存
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push({
          path: '/'
        })
      }
    })
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/loginPage/ssotempPage.vue